import { render, staticRenderFns } from "./AGCTextarea.vue?vue&type=template&id=0955cfda&"
import script from "./AGCTextarea.vue?vue&type=script&lang=js&"
export * from "./AGCTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports